var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.41 159.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e13433;}.cls-2{fill:#d7006c;}.cls-3{fill:#fff;}.cls-4{fill:#161615;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    className: "cls-1",
    d: "M75.56,159c-3.47.26-7,.39-10.57.43-25,.31-54.06-4.22-62.2-32-7.24-24.68.2-54.2,15.59-74.2C24.75,45,33.19,40.19,40.36,33c6.8-6.8,2.72-17.92,5-26.2,1.3-4.8,3.4-6,8.13-6.44,8.28-.84,17.08,0,25.41,0a9.85,9.85,0,0,1,3.92.52,6.65,6.65,0,0,1,3.55,4.6c2,7.89-3.17,20.86,4.1,26.87,10.61,8.79,20.73,15.39,28.41,27.34,13.22,20.59,18.53,47.47,7.44,70C115.81,150.86,97,157.41,75.55,159"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    className: "cls-2",
    d: "M3.34,84.22C4.86,79,18,81,22.9,82.38c8.77,2.4,17.14,5.52,26.2,7C72,93,101.86,84.24,124.27,80.64c6-1,6.7,6.16,7.12,10.45.8,8.18,4.32,25.54-8.88,27.15-25.61,3.12-51.38,4.16-77.19,4.18-12.51,0-35.89-2.28-44-13.76-3.06-4.35.72-20.09,2-24.44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    className: "cls-2",
    d: "M84.78,33C84,32,73.76,37,58.62,34.62,51.25,33.48,46.67,31.21,46,32c-.86,1,5.22,6.62,13.1,8.38,13.29,3,26.56-6.1,25.68-7.37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    className: "cls-2",
    d: "M84.78,11.35c-.74-1.06-11,3.93-26.16,1.59-7.37-1.13-11.95-3.4-12.62-2.6-.86,1,5.22,6.63,13.1,8.38,13.29,3,26.56-6.1,25.68-7.37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    className: "cls-2",
    d: "M96.79,42.68c-1.19-1.6-16.74,6.66-40.17,3.91C45.21,45.24,38,42,37.05,43.29c-1.26,1.64,8.42,9.9,20.63,12.16,20.61,3.83,40.53-10.86,39.11-12.77"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    className: "cls-3",
    d: "M65.13,2c9.14,0,16.54,2.17,16.54,4.84s-7.4,4.83-16.54,4.83S48.58,9.53,48.58,6.86,56,2,65.13,2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    className: "cls-4",
    d: "M65,3.11c7.17,0,13,1.7,13,3.8s-5.82,3.8-13,3.8S52,9,52,6.91s5.82-3.8,13-3.8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/Icon10.eb962693b094deca995a88da52809be7.svg";
export { ForwardRef as ReactComponent };